/** Short period phrase for listing stat subtitles, e.g. "(12 this week)". */
export function periodCaptionForTimeRangeLabel(timeRangeLabel) {
  const normalized = (timeRangeLabel || '').toLowerCase();
  if (normalized.includes('24 hour')) return 'today';
  if (normalized.includes('7 day')) return 'this week';
  if (normalized.includes('30 day')) return 'this month';
  return 'this period';
}

export function formatListingStatPeriodLine(periodValue, timeRangeLabel) {
  const count = Number(periodValue);
  if (!Number.isFinite(count)) return null;
  const caption = periodCaptionForTimeRangeLabel(timeRangeLabel);
  return `(${count.toLocaleString()} ${caption})`;
}
